export default {"src":"/_next/static/media/skills.8fc81155.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};